import React from 'react'
import ScopeChangeRequest from 'admin/scope-change-requests/ScopeChangeRequest'
import ScopeChangeRequestsViewModel from 'admin/scope-change-requests/ScopeChangeRequestsViewModel'
import { TableCell, TableRow } from 'components/Table/ClickableTable'
import { observer } from 'mobx-react'
import { ColumnId } from 'admin/scope-change-requests/ScopeChangeRequestsTableColumn'
import Icon from 'components/Icon'
import {
  formatPhase,
  formatTableStatus,
} from 'admin/scope-change-requests/formatters/scope-change-request-formatters'
import styles from './ScopeChangeRequestRow.sass'

interface ScopeChangeRequestRowProps {
  vm: ScopeChangeRequestsViewModel
  scopeChangeRequest: ScopeChangeRequest
}

export default observer(function ScopeChangeRequestRow({
  vm,
  scopeChangeRequest,
}: ScopeChangeRequestRowProps) {
  return (
    <TableRow
      className={styles.changeRequestRowRoot}
      onClick={() => vm.selectChangeRequest(scopeChangeRequest)}
      data-test={`scope-change-requests-list-item-${
        scopeChangeRequest.job.id
      }-${formatPhase(scopeChangeRequest.status)}`}
      active={
        vm.changeRequestDetailsVM.scopeChangeRequest.id ===
        scopeChangeRequest.id
      }
    >
      {vm.columns.map((column) => {
        switch (column.id) {
          case ColumnId.Details:
            return (
              <DetailsCell key={column.id} changeRequest={scopeChangeRequest} />
            )
          case ColumnId.Open:
            return (
              <TextCell key={column.id}>{scopeChangeRequest.open}</TextCell>
            )
          case ColumnId.Status:
            return (
              <TextCell key={column.id}>
                {formatTableStatus(scopeChangeRequest.status)}
              </TextCell>
            )
          case ColumnId.Action:
            return <ArrowCell key={column.id} />
          default:
            return <TableCell key={column.id} />
        }
      })}
    </TableRow>
  )
})

const defaultDateFormatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
})

interface DetailsCellProps {
  changeRequest: ScopeChangeRequest
}
const DetailsCell = observer(function DetailsCell({
  changeRequest,
}: DetailsCellProps) {
  return (
    <TableCell>
      <div className={styles.detailsRoot}>
        <div className={styles.detailsMain}>
          <div className={styles.detailsDate}>
            {defaultDateFormatter.format(changeRequest.createTime)}
          </div>
          <div className={styles.detailsSeparator}>•</div>
          <div className={styles.detailsShortId}>
            {changeRequest.job.shortId}
          </div>
        </div>
        <div className={styles.detailsDescription}>
          <div className={styles.jobName}>
            {changeRequest.workspace.name} | {changeRequest.job.displayName}
          </div>
        </div>
      </div>
    </TableCell>
  )
})

interface TextCellProps {
  children: string
}
const TextCell = observer(function RequestedByCell({
  children,
}: TextCellProps) {
  return (
    <TableCell>
      <div className={styles.text}>{children}</div>
    </TableCell>
  )
})

const ArrowCell = () => {
  return (
    <TableCell>
      <div className={styles.arrow}>
        <Icon name="arrow" size={24} />
      </div>
    </TableCell>
  )
}
